import { chakra } from '@chakra-ui/react'

export const LanguageSelectContainer = chakra('div', {
    baseStyle: ({ theme }) => ({
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.languageSelect.mobileBgColor,
        padding: '24px 24px 32px',
    }),
})

export const LanguageSelectTitle = chakra('div', {
    baseStyle: ({ theme }) => ({
        fontSize: '18px',
        fontWeight: 600,
        lineHeight: '28px',
        background: theme.palette.languageSelect.mobileTitleColor,
        padding: '16px 16px 8px',
        backgroundClip: 'text',
        textFillColor: 'transparent',
    }),
})
